<template>
   <div class="imgupload" v-loading="fullscreenLoading">
      <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline" size="mini" ref="sendDataInfo" :show-message="false">
         <el-form-item>
            <el-upload class="upload-demo" ref="upload" :action="requesUrl + url" :limit="limit" name="file" :headers="header" :on-preview="handlePreview" :file-list="fileList" :on-error="uploadFalse"
                       :on-success="uploadSuccess" :auto-upload="false" :http-request="handleUploadForm">
               <el-button slot="trigger" size="small" type="primary">选取excel文件</el-button>
               <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload()">提交上传</el-button>
            </el-upload>
         </el-form-item>
      </el-form>
   </div>
</template>
<script>
import $XLSX from "xlsx";

export default {
   name: 'initDataUpload',
   data() {
      return {
         file: "",
         tableData: [],
         tableHead: [],
         sendDataInfo: {
         },
         searchType: '',
         setField: '',
         nowField: "",
         fullscreenLoading: false,
         fileList: [],
         sField: '',
         requesUrl: '',
         otherData: {
            state: 0
         },
      };
   },
   props: {
      header: {
         type: Object,
         default: () => {
            return {
               'Content-Type': 'multipart/form-data',
               token: sessionStorage.getItem('token')
            }
         },
      },
      // 最大上传数量
      limit: {
         type: [Number, String],
         default: () => 1,
      },
      url: {
         type: String,
         require: true
      },
      errorUrl: {//错误
         type: String,
         require: false
      },
      listShow: {//是否根据导入返回的数据列表展示
         type: Boolean,
         require: false
      },
      importType: {
         type: String,
         require: true,
      },
      parentSearchData: {
         type: Object,
         require: false,
      },
   },
   created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.fileList = []
   },
   methods: {
      handleUploadForm(param) {
         let formData = new FormData()

         // 在formData中加入我们需要的参数
         formData.append('file', param.file)
         formData.append('state', 0)
         if (this.url == 'woApply/exportSuDetail') {
            formData.append('stId', this.parentSearchData.stId)
            formData.append('coId', this.parentSearchData.coId)

         } else if (this.url == 'RgApply/exportReturnDetail') {
            formData.append('opmId', this.parentSearchData.opmId)
            formData.append('smId', this.parentSearchData.smId)
            formData.append('coId', this.parentSearchData.coId)
            formData.append('salesId', this.parentSearchData.salesId)
         }else if(this.url == 'pisplanorder/exportPisDetail'){
            formData.append('formId', this.parentSearchData.formId)
            formData.append('salesId', this.parentSearchData.salesId)
            formData.append('unitId', this.parentSearchData.unitId)
         }else if(this.url == 'pisplanorder/exportStepPisDetail'){
            formData.append('formId', this.parentSearchData.formId)
            formData.append('salesId', this.parentSearchData.salesId)
            formData.append('unitId', this.parentSearchData.unitId)
         }
         if (this.parentSearchData) {
            Object.keys(this.parentSearchData).forEach(key => {
               formData.append(key, this.parentSearchData[key])
            })
         }
         // 向后端发送数据
         this.$http[this.importType](formData).then((res) => {
            console.log(res);
            if (res.status === 200) {
               this.$message.success('上传成功')
               this.fileList = []
               if (this.url == 'pisplanorder/exportPisDetail' || this.url == 'woApply/exportSuDetail' || this.url == 'RgApply/exportReturnDetail' || this.listShow) {
                  this.$emit('closeExcel', { list: res.result, type: true })
                  return
               }
               this.$emit('closeExcel', true)
            } else if (res.status === 300) {
               this.$message.error('导入数据有误，请下载文档核对！')
               this.fileList = []
               if (this.url == 'GSPgoods/exportLicence') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/GSPgoods/exportGoodLicenceFail`
               } else if (this.url == 'GSPgoods/exportinit') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/GSPgoods/exportGoodFail`
               } else if (this.url == 'gspSupplier/exportinit') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspSupplier/exportSupFail`
               } else if (this.url == 'gspSupplier/exportSupLicence') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspSupplier/exportSupLicenceFail`
               } else if (this.url == 'gspCustomer/exportCusLicence') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspCustomer/exportCusLicenceFail`
               } else if (this.url == 'gspCustomer/exportinit') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/gspCustomer/exportCusFail`
               } else if (this.url == 'bgStock/exportStockInit') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/bgStock/exportStockFail`
               } else if (this.url == 'klPuorder/upload') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/klPuorder/importTemplate`
               } else if (this.url == 'klSuorder/upload') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/klSuorder/importTemplate`
               } else if (this.url == 'currentReset/exportSupAccount') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/currentReset/exportSupAccountFail`
               } else if (this.url == 'currentReset/exportCusAccount') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/currentReset/exportCusAccountFail`
               } else if (this.url == 'pisplanorder/exportPisDetail') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/pisplanorder/exportPisFail`
               } else if (this.url == 'woApply/exportSuDetail') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/woApply/exportSuFail`
               } else if (this.url == 'RgApply/exportReturnDetail') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/RgApply/exportStockReturnFail`
               } else if (this.url == 'supriceList/exportReturnDetail') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/supriceList/exportFail`
               } else if (this.url == 'surgerymaster/exporSurgery') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/surgerymaster/exportFail`
               } else if (this.url == 'member/importExcel') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/member/exportFail`
               } else if (this.url == 'sellPlan/importExcel') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/sellPlan/exportFail`
               } else if (this.url == 'sellPlan/importCLCXExcel') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/sellPlan/importCLCXExcel`
               } else if (this.url == 'sudrawbill/importSudrawbill') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/sudrawbill/exportBillFail`
               } else if (this.url == 'cashFlow/exportCashFlow') {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/cashFlow/exportFail`
               } else if (this.errorUrl) {
                  window.location.href = `${this.$store.getters.getConfig.requestUrl}/${this.errorUrl}`
               }
               this.$emit('closeExcel', false)
            } else {
               this.fileList = []
               this.$message.error(res.message)
            }
         })
      },
      uploadSuccess(response, file, fileList) {
         console.log(response);
         if (response.status == 0) {
            console.log("文件导入成功");
         } else {
            console.log("文件导入失败");
         }
      },
      uploadFalse(response, file, fileList) {
         console.log(response);
         alert("文件上传失败！");
      },
      // 导入成功时执行
      handleChange(file, fileList) {
         console.log('handleChange', file, '--', fileList);
         this.fileList = JSON.parse(JSON.stringify(fileList))
      },
      readExcel(file) {
         const fileReader = new FileReader();
         fileReader.onload = ev => {
            try {
               const data = ev.target.result;
               const workbook = $XLSX.read(data, { type: "binary" });
               const params = [];
               this.tableData = [], this.tableHead = [];
               // 取对应表生成json表格内容
               workbook.SheetNames.forEach(item => {
                  this.tableData.push($XLSX.utils.sheet_to_json(workbook.Sheets[item]));
               });
               console.log('workbook', JSON.parse(JSON.stringify(this.tableData)));
               // 该算法仅针对表头无合并的情况
               if (this.tableData.length > 0) {
                  // 获取excel中第一个表格数据tableData[0][0]，并且将表头提取出来
                  for (const key in this.tableData[0][0]) {
                     this.tableHead.push(key);
                  }
               }
               // 重写数据
            } catch (e) {
               console.log("error:" + e);
               return false;
            }
         };
         fileReader.readAsBinaryString(file[0].raw);
      },
      // 上传前对文件的大小的判断
      beforeAvatarUpload(file) {
      },
      // 触发组件的提交
      submitUpload() {
         this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
         let len = this.fileList.length
         if (len > 0) {
            for (let i = 0; i < len; i++) {
               if (file.name == this.fileList[i].name) {
                  this.fileList.splice(i, 1)
                  break;
               }
            }
         }
      },
      handlePreview(file) {
         console.log(file);
         if (file.status) {
            alert("此文件导入成功");
         } else {
            alert("此文件导入失败");
         }
      },
   },
};
</script>
<style scoped>
.imgupload {
   margin-left: 68px;
}
</style>